export const REGISTER_USER = "REGISTER_USER"
export const REGISTER_USER_SUCCESSFULL = "REGISTER_USER_SUCCESSFULL"
export const REGISTER_USER_FAILED = "REGISTER_USER_FAILED"
